/**
 * SuiteIcon — official brand icon for one of the four suite apps.
 *   • LT  / LWT  → /suite-lwt-icon.png
 *   • TD         → /suite-td-icon.png
 *   • TVD        → /suite-tvd-icon.png
 *   • FT         → text wordmark "FT" in the FT brand colour (no PNG yet)
 *
 * If an asset is missing or fails to load, we render a coloured text
 * wordmark fallback so the badge never collapses to a broken image icon.
 */
const SRC = {
  lt:  '/suite-lwt-icon.png',  // canonical key — alias of lwt
  lwt: '/suite-lwt-icon.png',
  td:  '/suite-td-icon.png',
  tvd: '/suite-tvd-icon.png',
  ft:  null,                   // text-only badge for now
};

const ALT = {
  lt:  'Learn With Trust',
  lwt: 'Learn With Trust',
  td:  'Trust Design',
  tvd: 'Trust Visual Director',
  ft:  'Financial Trust',
};

const FALLBACK_TEXT = {
  lt: 'LT', lwt: 'LT', td: 'TD', tvd: 'TVD', ft: 'FT',
};

const FALLBACK_COLOR = {
  lt:  '#4F46E5',  // indigo-600
  lwt: '#4F46E5',
  td:  '#10B981',  // emerald-500
  tvd: '#D946EF',  // fuchsia-500
  ft:  '#0EA5E9',  // sky-500
};

const TextWordmark = ({ app, size }) => (
  <span
    className="inline-flex items-center justify-center font-extrabold leading-none tracking-tight"
    style={{
      width: size,
      height: size,
      fontSize: Math.max(8, Math.round(size * 0.42)),
      color: FALLBACK_COLOR[app] || '#4F46E5',
    }}
    aria-label={ALT[app] || app}
  >
    {FALLBACK_TEXT[app] || String(app).toUpperCase()}
  </span>
);

const SuiteIcon = ({ app = 'td', size = 24, className = '', rounded = true }) => {
  const src = SRC[app];
  if (!src) return <TextWordmark app={app} size={size} />;
  return (
    <img
      src={src}
      alt={ALT[app] || app}
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      onError={(e) => {
        // graceful fallback if PNG is missing on the host
        e.currentTarget.style.display = 'none';
      }}
      className={`object-contain ${rounded ? 'rounded-md' : ''} ${className}`}
      style={{ width: size, height: size }}
    />
  );
};

export default SuiteIcon;
